import { useEffect, useState } from "react";

export function useScreenMode() {
  const [isMobile, setIsMobile] = useState(window.screen.width <= 868);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 868);
    };

    window.addEventListener("resize", handleResize);

    // Проверка режима экрана при первой загрузке
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isMobile;
}